export var AdminWithdrawStatusType;
(function (AdminWithdrawStatusType) {
    AdminWithdrawStatusType[AdminWithdrawStatusType["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    AdminWithdrawStatusType[AdminWithdrawStatusType["SUCCESSFUL"] = 2] = "SUCCESSFUL";
    AdminWithdrawStatusType[AdminWithdrawStatusType["THIRD_PARTY_WITHDRAWING"] = 3] = "THIRD_PARTY_WITHDRAWING";
    AdminWithdrawStatusType[AdminWithdrawStatusType["CANCEL"] = 4] = "CANCEL";
    AdminWithdrawStatusType[AdminWithdrawStatusType["THIRD_PARTY_WITHDRAW_FAIL"] = 5] = "THIRD_PARTY_WITHDRAW_FAIL";
    AdminWithdrawStatusType[AdminWithdrawStatusType["REVIEWING"] = 6] = "REVIEWING";
})(AdminWithdrawStatusType || (AdminWithdrawStatusType = {}));
//# sourceMappingURL=AdminWithdrawStatusType.js.map